import { EventBus } from "@/event-bus.js";
export default{
    methods:{
        deleteRowShowModal(index, fieldData){
            EventBus.$emit("onShowDeletModal", index, fieldData);
            // return 'file can be delete from there'
        }
    }
}